// // import React from "react";
// // import hexalogo from "../image/logo.png";
// // import hexatrademark from "../image/hexaphi.jpg";
// // import isours from "../image/iso-urs.png";

// // export default function HeroSection() {
// //   return (
// //     <section className="bg-white border border-red-800 w-full p-6 md:p-10">
// //       <div className="grid grid-cols-12 items-center gap-4">
// //         {/* Left Logo - 3 Columns */}
// //         <div className="col-span-3 flex justify-start">
// //           <img
// //             src={hexalogo}
// //             alt="Hexa Electronics Logo"
// //             className="h-20 md:h-28 w-auto"
// //           />
// //         </div>

// //         {/* Center Text - 4 Columns */}
// //         <div className="col-span-4 text-center">
// //           <h1 className="text-3xl md:text-4xl font-extrabold text-red-800">
// //             Hexa Electronics Pvt. Ltd.
// //           </h1>
// //           <p className="text-xl md:text-2xl font-semibold text-blue-700 mt-1">
// //             Imagination to Innovation
// //           </p>
// //         </div>

// //         {/* Trademark Logo - 3 Columns */}
// //         <div className="col-span-3 flex justify-start">
// //           <img
// //             src={hexatrademark}
// //             alt="Trademark"
// //             className="h-24 md:h-36 w-auto"
// //           />
// //         </div>

// //         {/* ISO Logo - 2 Columns */}
// //         <div className="col-span-2 flex flex-col items-end">
// //           <img
// //             src={isours}
// //             alt="ISO 9001:2015"
// //             className="h-10 md:h-14 w-auto"
// //           />
// //           <span className="text-xs md:text-sm font-semibold text-blue-800 mt-1">
// //             ISO 9001:2015
// //           </span>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // }

// import React from "react";
// import hexalogo from "../image/logo.png";
// import hexatrademark from "../image/hexaphi.jpg";
// import isours from "../image/iso-urs.png";

// export default function HeroSection() {
//   return (
//     <section className="bg-white border border-red-800 w-full p-6 md:p-10">
//       <div className="grid grid-cols-12 items-center gap-4">
//         {/* Hexa Logo - 3 Columns */}
//         {/* <div className="col-span-3 flex justify-start">
//           <img
//             src={hexalogo}
//             alt="Hexa Electronics Logo"
//             className="h-20 md:h-28 w-auto"
//           />
//         </div> */}

//         <div className="col-span-3 flex justify-start">
//           <img
//             src={hexalogo}
//             alt="Hexa Electronics Logo"
//             className="h-28 md:h-44 w-auto"
//           />
//         </div>

//         {/* Center Text - 5 Columns */}
//         {/* <div className="col-span-5 text-center">
//           <h1 className="text-3xl md:text-4xl font-extrabold text-red-800">
//             Hexa Electronics Pvt. Ltd.
//           </h1>
//           <p className="text-xl md:text-2xl font-semibold text-blue-700 mt-1">
//             Imagination to Innovation
//           </p>
//         </div> */}

//         {/* Center Text - 5 Columns */}
//         <div className="col-span-5 text-center">
//           <h1 className="text-4xl md:text-5xl font-extrabold text-red-800 leading-tight">
//             Hexa Electronics Pvt. Ltd.
//           </h1>
//           <p className="text-2xl md:text-3xl font-semibold text-blue-700 mt-2">
//             Imagination to Innovation
//           </p>
//         </div>

//         {/* Hexa Trademark - 2 Columns */}
//         <div className="col-span-2 flex justify-start">
//           <img
//             src={hexatrademark}
//             alt="Trademark"
//             className="h-28 md:h-44 w-auto"
//           />
//         </div>

//         {/* <img
//           src={hexatrademark}
//           alt="Trademark"
//           className="h-30 md:h-50 w-auto"
//         /> */}

//         {/* ISO Logo - 2 Columns */}
//         <div className="col-span-2 flex flex-col items-end">
//           <img
//             src={isours}
//             alt="ISO 9001:2015"
//             className="h-10 md:h-14 w-auto"
//           />
//           <span className="text-xs md:text-sm font-semibold text-blue-800 mt-1">
//             ISO 9001:2015
//           </span>
//         </div>
//       </div>
//     </section>
//   );
// }

// import React from "react";
// import hexalogo from "../image/logo.png";
// import hexatrademark from "../image/hexaphi.jpg";
// import isours from "../image/iso-urs.png";

// export default function HeroSection() {
//   return (
//     <section className="bg-white border border-red-800 w-full p-4 sm:p-6 md:p-10">
//       <div className="grid grid-cols-12 items-center gap-2 sm:gap-4">
//         {/* Hexa Logo - full width on xs, 3 cols on sm+ */}
//         <div className="col-span-12 sm:col-span-2 flex justify-center sm:justify-start mb-4 sm:mb-0">
//           <img
//             src={hexalogo}
//             alt="Hexa Electronics Logo"
//             className="h-20 sm:h-28 md:h-44 w-auto"
//           />
//         </div>

//         {/* Center Text - full width xs, 5 cols sm+ */}
//         <div className="col-span-12 sm:col-span-5 text-center sm:text-center mb-4 sm:mb-0">
//           <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-red-800 leading-tight">
//             Hexa Electronics Pvt. Ltd.
//           </h1>
//           <p className="text-lg sm:text-2xl md:text-3xl font-semibold text-blue-700 mt-1 sm:mt-2">
//             Imagination to Innovation
//           </p>
//         </div>

//         {/* Hexa Trademark - full width xs, 2 cols sm+ */}
//         <div className="col-span-12 sm:col-span-4 flex  sm:justify-center mb-4 sm:mb-0">
//           <img
//             src={hexatrademark}
//             alt="Trademark"
//             className="h-16 sm:h-28 md:h-44 w-auto"
//           />
//         </div>

//         {/* ISO Logo - full width xs, 2 cols sm+ */}
//         <div className="col-span-12 sm:col-span-1 flex justify-center sm:justify-end items-center">
//           <div className="flex flex-col items-center sm:items-end">
//             <img
//               src={isours}
//               alt="ISO 9001:2015"
//               className="h-8 sm:h-14 w-auto"
//             />
//             <span className="text-xs sm:text-sm font-semibold text-blue-800 mt-1">
//               ISO 9001:2015
//             </span>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React from "react";
import hexalogo from "../image/logo.png";
import hexatrademark from "../image/hexaphi.jpg";
import isours from "../image/iso-urs.png";

export default function HeroSection() {
  return (
    <section className="bg-white border border-red-800 w-full p-4 sm:p-6 md:p-10">
      <div className="grid grid-cols-12 items-center gap-4">
        {/* Hexa Logo - full width on mobile, 2 cols on sm+ */}
        <div className="col-span-12 sm:col-span-2 flex justify-center sm:justify-start">
          <img
            src={hexalogo}
            alt="Hexa Electronics Logo"
            className="h-20 sm:h-28 md:h-36 w-auto"
          />
        </div>

        {/* Center Text - full width on mobile, 6 cols on sm+ */}
        <div className="col-span-12 sm:col-span-6 text-center sm:text-left">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-red-800 leading-tight">
            Hexa Electronics Pvt. Ltd.
          </h1>
          <p className="text-lg sm:text-2xl md:text-3xl font-semibold text-blue-700 mt-1 sm:mt-2">
            Imagination to Innovation
          </p>
        </div>

        {/* Trademark - full width mobile, 3 cols on sm+ */}
        <div className="col-span-12 sm:col-span-3 flex justify-center sm:justify-center">
          <img
            src={hexatrademark}
            alt="Trademark"
            className="h-20 sm:h-32 md:h-44 w-auto"
          />
        </div>

        {/* ISO Logo - center on mobile, right on desktop */}
        <div className="col-span-12 sm:col-span-1 flex justify-center sm:justify-end">
          <div className="flex flex-col items-center sm:items-end">
            <img
              src={isours}
              alt="ISO 9001:2015"
              className="h-8 sm:h-12 md:h-14 w-auto"
            />
            <span className="text-xs sm:text-sm font-semibold text-blue-800 mt-1">
              ISO 9001:2015
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
